export const mutationType = {
    UPDATE_VALUE: 'UPDATE_VALUE',
    INIT_FORM: 'INIT_FORM',
    REMOVE_FORM: 'REMOVE_FORM',
}
